import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'md'
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-1200">
      <div ref={modalRef} className={`relative w-full ${maxWidthClasses[maxWidth]} bg-white rounded-lg shadow-xl animate-in zoom-in-95 duration-200`} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-1201">
        <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-1202">
          <h2 id="modal-title" className="text-lg font-semibold text-gray-900" data-id="element-1203">
            {title}
          </h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-1204">
            <X className="h-5 w-5" data-id="element-1205" />
          </button>
        </div>
        <div className="p-6" data-id="element-1206">{children}</div>
      </div>
    </div>;
}